import Form from "react-bootstrap/Form";
import OrderCard from "../components/orderCard";
import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";
import { useState } from "react";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import {
  fetchSearchOrderApi,
  searchOrderData,
} from "../signals/orderData.signal";
import SearchOrderCard from "../components/searchOrderCard";

const MyOrder = () => {
  const [Search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  if (!Search) {
    searchOrderData.value = null;
  }
  
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };
  const handleSubmit = async (event) => {
    setLoading(true);
    setDisabled(true);
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        const response = await fetchSearchOrderApi(Search);

        if (response) {
          searchOrderData.value = response;
        } else {
          console.error("Authentication failed");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
        setDisabled(false);
      }
    }
  };
  return (
    <div
      id="myOrder"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "MyOrderTitle")}
      />
      <Form
        onSubmit={handleSubmit}
        className="align-items-sm-center d-flex justify-content-center w-100 p-3"
      >
        <div className="loginContaner bg-white p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
          <div className="mb-1  w-100 ">
            <div className="input-group">
              <input
                type="text"
                className="form-control rounded-3"
                id="Search"
                value={Search}
                placeholder={translateText(
                  currentLanguage.value,
                  "SearchTitle"
                )}
                onChange={handleSearchChange}
                required
              />
              <button
                type="submit" 
                className="btn btn-primary border rounded-3"
                style={{ background: primary.value, color: primaryFount.value }}
                id="button-addon2"
                disabled={disabled}
              >
                {loading
                  ? translateText(currentLanguage.value, "Loading") + "..."
                  : translateText(currentLanguage.value, "Search")}
              </button>
            </div>
          </div>
          <SearchOrderCard />
        </div>
      </Form>
      <OrderCard />
    </div>
  );
};

export default MyOrder;
